/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ErrorView } from '../model';
// @ts-ignore
import { SearchReadView } from '../model';
// @ts-ignore
import { UnitListView } from '../model';
// @ts-ignore
import { UnitReadView } from '../model';
/**
 * UnitApi - axios parameter creator
 * @export
 */
export const UnitApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Search for things
     * @param {string} query Search term
     * @param {number} limit Maximum amount of items per kind
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchResourceList: async (
      query: string,
      limit: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'query' is not null or undefined
      assertParamExists('searchResourceList', 'query', query);
      // verify required parameter 'limit' is not null or undefined
      assertParamExists('searchResourceList', 'limit', limit);
      const localVarPath = `/v1/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication default required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      if (query !== undefined) {
        localVarQueryParameter['query'] = query;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary List units
     * @param {number} [limit] Maximum amount of items per page
     * @param {number} [offset] Page offset
     * @param {number} [contractId] Filter by contract
     * @param {number} [organisationId] Filter by organisation
     * @param {number} [propertyId] Filter by property
     * @param {string} [search] Filter by search term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unitResourceList: async (
      limit?: number,
      offset?: number,
      contractId?: number,
      organisationId?: number,
      propertyId?: number,
      search?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/units`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication default required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (contractId !== undefined) {
        localVarQueryParameter['contractId'] = contractId;
      }

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      if (propertyId !== undefined) {
        localVarQueryParameter['propertyId'] = propertyId;
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Read a unit
     * @param {number} id Unit ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unitResourceRead: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('unitResourceRead', 'id', id);
      const localVarPath = `/v1/units/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication default required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * UnitApi - functional programming interface
 * @export
 */
export const UnitApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UnitApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Search for things
     * @param {string} query Search term
     * @param {number} limit Maximum amount of items per kind
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchResourceList(
      query: string,
      limit: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchReadView>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchResourceList(query, limit, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary List units
     * @param {number} [limit] Maximum amount of items per page
     * @param {number} [offset] Page offset
     * @param {number} [contractId] Filter by contract
     * @param {number} [organisationId] Filter by organisation
     * @param {number} [propertyId] Filter by property
     * @param {string} [search] Filter by search term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unitResourceList(
      limit?: number,
      offset?: number,
      contractId?: number,
      organisationId?: number,
      propertyId?: number,
      search?: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitListView>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.unitResourceList(
        limit,
        offset,
        contractId,
        organisationId,
        propertyId,
        search,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Read a unit
     * @param {number} id Unit ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unitResourceRead(
      id: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitReadView>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.unitResourceRead(id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};

/**
 * UnitApi - factory interface
 * @export
 */
export const UnitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = UnitApiFp(configuration);
  return {
    /**
     *
     * @summary Search for things
     * @param {string} query Search term
     * @param {number} limit Maximum amount of items per kind
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchResourceList(query: string, limit: number, options?: any): AxiosPromise<SearchReadView> {
      return localVarFp.searchResourceList(query, limit, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List units
     * @param {number} [limit] Maximum amount of items per page
     * @param {number} [offset] Page offset
     * @param {number} [contractId] Filter by contract
     * @param {number} [organisationId] Filter by organisation
     * @param {number} [propertyId] Filter by property
     * @param {string} [search] Filter by search term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unitResourceList(
      limit?: number,
      offset?: number,
      contractId?: number,
      organisationId?: number,
      propertyId?: number,
      search?: string,
      options?: any
    ): AxiosPromise<UnitListView> {
      return localVarFp
        .unitResourceList(limit, offset, contractId, organisationId, propertyId, search, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Read a unit
     * @param {number} id Unit ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unitResourceRead(id: number, options?: any): AxiosPromise<UnitReadView> {
      return localVarFp.unitResourceRead(id, options).then((request) => request(axios, basePath));
    }
  };
};

/**
 * Request parameters for searchResourceList operation in UnitApi.
 * @export
 * @interface UnitApiSearchResourceListRequest
 */
export interface UnitApiSearchResourceListRequest {
  /**
   * Search term
   * @type {string}
   * @memberof UnitApiSearchResourceList
   */
  readonly query: string;

  /**
   * Maximum amount of items per kind
   * @type {number}
   * @memberof UnitApiSearchResourceList
   */
  readonly limit: number;
}

/**
 * Request parameters for unitResourceList operation in UnitApi.
 * @export
 * @interface UnitApiUnitResourceListRequest
 */
export interface UnitApiUnitResourceListRequest {
  /**
   * Maximum amount of items per page
   * @type {number}
   * @memberof UnitApiUnitResourceList
   */
  readonly limit?: number;

  /**
   * Page offset
   * @type {number}
   * @memberof UnitApiUnitResourceList
   */
  readonly offset?: number;

  /**
   * Filter by contract
   * @type {number}
   * @memberof UnitApiUnitResourceList
   */
  readonly contractId?: number;

  /**
   * Filter by organisation
   * @type {number}
   * @memberof UnitApiUnitResourceList
   */
  readonly organisationId?: number;

  /**
   * Filter by property
   * @type {number}
   * @memberof UnitApiUnitResourceList
   */
  readonly propertyId?: number;

  /**
   * Filter by search term
   * @type {string}
   * @memberof UnitApiUnitResourceList
   */
  readonly search?: string;
}

/**
 * Request parameters for unitResourceRead operation in UnitApi.
 * @export
 * @interface UnitApiUnitResourceReadRequest
 */
export interface UnitApiUnitResourceReadRequest {
  /**
   * Unit ID
   * @type {number}
   * @memberof UnitApiUnitResourceRead
   */
  readonly id: number;
}

/**
 * UnitApi - object-oriented interface
 * @export
 * @class UnitApi
 * @extends {BaseAPI}
 */
export class UnitApi extends BaseAPI {
  /**
   *
   * @summary Search for things
   * @param {UnitApiSearchResourceListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnitApi
   */
  public searchResourceList(requestParameters: UnitApiSearchResourceListRequest, options?: AxiosRequestConfig) {
    return UnitApiFp(this.configuration)
      .searchResourceList(requestParameters.query, requestParameters.limit, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List units
   * @param {UnitApiUnitResourceListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnitApi
   */
  public unitResourceList(requestParameters: UnitApiUnitResourceListRequest = {}, options?: AxiosRequestConfig) {
    return UnitApiFp(this.configuration)
      .unitResourceList(
        requestParameters.limit,
        requestParameters.offset,
        requestParameters.contractId,
        requestParameters.organisationId,
        requestParameters.propertyId,
        requestParameters.search,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Read a unit
   * @param {UnitApiUnitResourceReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnitApi
   */
  public unitResourceRead(requestParameters: UnitApiUnitResourceReadRequest, options?: AxiosRequestConfig) {
    return UnitApiFp(this.configuration)
      .unitResourceRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
